import { render } from "./LeituraPessoafisica.vue?vue&type=template&id=320c4320"
import script from "./LeituraPessoafisica.vue?vue&type=script&lang=js"
export * from "./LeituraPessoafisica.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__